/**
 * NotFoundPage — 404. Cursor becomes a magnifier.
 */

import { Box, Button, Stack, Typography } from '@mui/material';
import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export function NotFoundPage(): ReactElement {
  const [pos, setPos] = useState<{ x: number; y: number }>({ x: 0, y: 0 });

  useEffect(() => {
    function onMove(e: MouseEvent): void {
      setPos({ x: e.clientX, y: e.clientY });
    }
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'none',
        position: 'relative',
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          position: 'fixed',
          left: pos.x - 12,
          top: pos.y - 12,
          fontSize: 22,
          pointerEvents: 'none',
          zIndex: 9999,
          filter: 'drop-shadow(0 0 4px rgba(217, 119, 87, 0.55))',
          transition: 'transform 80ms ease',
        }}
      >
        🔍
      </Box>

      <Stack spacing={3} alignItems="center" sx={{ p: 3, textAlign: 'center' }}>
        <Typography
          variant="h2"
          sx={{
            fontFamily: '"JetBrains Mono", monospace',
            color: 'primary.main',
            textShadow: '0 0 6px rgba(217, 119, 87, 0.55)',
          }}
        >
          404 — case not found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          &ldquo;Elementary, my dear Watson — this case doesn&apos;t exist.&rdquo;
        </Typography>
        <Button component={RouterLink} to="/insights" variant="contained">
          ▸ back to insights
        </Button>
      </Stack>
    </Box>
  );
}
